import { useEffect, useRef } from "react";

export const useClickOutside = <T extends HTMLElement>(
  memoizedHandler: (event: FocusEvent) => void,
  id?: string
) => {
  const clickOutsideRef = useRef<T>(null);

  useEffect(() => {
    const listener = (event: FocusEvent) => {
      const clickOutsideElement = clickOutsideRef.current;

      if (
        (!clickOutsideElement ||
          clickOutsideElement.contains(event.target as Node)) &&
        (!id ||
          document.querySelector(id)?.contains(event.relatedTarget as Node))
      ) {
        return;
      }

      memoizedHandler(event);
    };

    document.addEventListener("click", listener);

    return () => {
      document.removeEventListener("click", listener);
    };
  }, [clickOutsideRef, memoizedHandler, id]);

  return {
    clickOutsideRef,
  };
};
